module.exports = __webpack_public_path__ + "static/media/white_category_icon_c2.00efd8e3.svg";